var plugins = {
  tus: null as any,
};

export default plugins;